<template>
    <div>
        <div class="row">
            <div class="col-xl-2 col-md-6">
                <div class="form-group">
                    <label>{{ __('general.country') }}</label><br>
                    <select v-model="value.country"
                            class="selectpicker w-100"
                            data-style="btn btn-default text-dark"
                            id="k_form_country"
                            tabindex="-97">
                        <option value="" :selected="value.country === ''">
                            {{ __('actions.show.all') }}
                        </option>
                        <option v-for="(country, locale) in countries" :value="locale"
                                :selected="value.country === locale">{{ country }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-xl-2 col-md-6">
                <div class="form-group">
                    <label>{{ __('general.status') }}</label><br>
                    <select v-model="value.active"
                            class="selectpicker w-100"
                            data-style="btn btn-default text-dark"
                            id="k_form_status"
                            tabindex="-98">
                        <option :value="undefined" :selected="value.active === ''">{{ __('actions.show.all') }}</option>
                        <option :value="true" :selected="value.active === true"
                                data-icon="fas fa-check-circle text-success">&nbsp;{{ __('actions.show.active') }}
                        </option>
                        <option :value="false" :selected="value.active === false"
                                data-icon="fas fa-times-circle text-danger">&nbsp;{{ __('actions.show.inactive') }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-xl-3 col-md-6">
                <div class="form-group">
                    <label>{{ __('store.name') }}</label>
                    <ClearableInput v-model="value.name" :placeholder="__('actions.filter.name')" icon="fas fa-filter"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="form-group">
                    <label>{{ __('store.city') }}</label>
                    <ClearableInput v-model="value.city" :placeholder="__('actions.filter.city')" icon="fas fa-filter"/>
                </div>
            </div>
            <div class="col-xl-2 col-md-6">
                <div class="form-group">
                    <label>{{ __('general.postcode') }}</label>
                    <ClearableInput v-model="value.postcode" :placeholder="__('actions.filter.postcode')" icon="fas fa-filter"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClearableInput from '@components/Form/ClearableInput.vue'

export default {
    components: {ClearableInput},

    props: {
        value: [Array, Object],
        countries: Object,
    },

    watch: {
        value: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            },
        },
    },
}
</script>
